import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container, IconButton, Typography } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"
import CustomLink from "../../components/custom-link/custom-link.component"

export const Section = styled(SectionWrapper)`
  ${({ theme }) => theme.breakpoints.down("md")} {
    padding: 5rem 0;
  }
`

export const Wrapper = styled(Container)``

export const CardContainer = styled.div`
  &:hover {
    .gatsby-image-wrapper {
      transform: scale(1.1);
    }
    div {
      &.buttons-container {
        opacity: 1;
      }
    }
  }
`

export const Image = styled(CustomImage)`
  border-radius: 16px;
  overflow: hidden;
  height: 300px;
  ${({ theme }) => theme.breakpoints.up("lg")} {
    height: 358px;
  }
  .gatsby-image-wrapper {
    width: 100%;
    object-fit: cover !important;
    transition: 0.3s ease-in-out;
  }
`

export const DescriptionContainer = styled.div``

export const Description = styled.div`
  display: flex;
  align-items: center;
  column-gap: 0.5rem;
  margin-top: ${({ theme }) => theme.typography.pxToRem(24)};
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(12)};
  span,
  p {
    font-size: ${({ theme }) => theme.typography.pxToRem(17)};
    font-style: normal;
    line-height: ${({ theme }) => theme.typography.pxToRem(24)};
  }

  span {
    color: ${({ theme }) => theme.palette.tertiary.dark};
    text-transform: uppercase;
    font-weight: 600;
  }

  p {
    color: ${({ theme }) => theme.palette.primary.main};
    font-weight: 500;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    span,
    p {
      font-size: ${({ theme }) => theme.typography.pxToRem(16)};
    }
  }
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: ${({ theme }) => theme.typography.pxToRem(22)};
  font-style: normal;
  line-height: ${({ theme }) => theme.typography.pxToRem(32)};
  font-weight: 500;

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(20)};
    line-height: ${({ theme }) => theme.typography.pxToRem(28)};
  }
`

export const ShareContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 0.8rem;
  margin-top: 1rem;
  opacity: 1;
  transition: 0.3s ease-in-out;
  p {
    color: ${({ theme }) => theme.palette.primary.main};
    font-size: ${({ theme }) => theme.typography.pxToRem(16)};
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  ${({ theme }) => theme.breakpoints.up("md")} {
    opacity: 0;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 0.5rem;
`

export const Button = styled(IconButton)`
  border-radius: 50px;
  background: rgba(0, 161, 121, 0.07);
  display: flex;
  width: 52px;
  height: 52px;
  padding: 8px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const SearchContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(40)};
  padding-left: 4rem;

  ${({ theme }) => theme.breakpoints.down("md")} {
    padding-left: 0;
  }
`

export const CategoriesContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 4rem;
  row-gap: 0.5rem;
`

export const Label = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: ${({ theme }) => theme.typography.pxToRem(18)};
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.18px;
  text-transform: capitalize;
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(14)};
`

export const Categorie = styled(CustomLink)`
  color: ${({ theme }) => theme.palette.tertiary.dark};
  font-size: ${({ theme }) => theme.typography.pxToRem(18)};
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  line-height: ${({ theme }) => theme.typography.pxToRem(24)};

  &.active {
    text-decoration: underline;
  }
`

export const LoadMoreButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${({ theme }) => theme.typography.pxToRem(16)};
  width: 100%;
`

export const Message = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: ${({ theme }) => theme.typography.pxToRem(18)};
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  line-height: ${({ theme }) => theme.typography.pxToRem(24)};
  display: flex;
  justify-content: center;
`
